"use client"

import Script from "next/script"
import { CookieBanner } from "./CookieBanner"

/**
 * Main component for managing analytics.
 * It orchestrates Google Analytics consent and script loading based on user preferences.
 *
 * @param {object} props - The component props.
 * @param {boolean} props.hasConsent - Indicates whether the user has consented to cookies.
 * This is typically determined server-side by checking for the `CONSENT_COOKIE`.
 */
export function Analytics({ hasConsent }: { hasConsent: boolean }) {
  return (
    <>
      {hasConsent && (
        <Script
          id="gtm-consent-update"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: `
              gtag('consent', 'update', {
                'ad_storage': 'granted',
                'analytics_storage': 'granted'
              });
            `,
          }}
        />
      )}

      {!hasConsent && <CookieBanner />}
    </>
  )
}
